module.exports = __webpack_public_path__ + "img/david-jumping.52a86575.jpg";